import { scaleRating } from '@guuru/rating-common';
import ms from 'ms';
import { findInCurve } from './distribution';

const score = ({
  distribution,
  msSinceActive,
  rating: expertRating = 0.75,
} = {}) => {
  const { activity, rating } = distribution;
  const lastTimeActive = msSinceActive ?? ms('10m');
  const expActvScore = findInCurve(activity, lastTimeActive, (x, y) => x >= y);
  const expRatingScore = findInCurve(rating, expertRating, (x, y) => x <= y);
  return expActvScore * expRatingScore;
};

const metrics = ({
  role,
  bucket,
  lastAcceptedAt,
  rating,
  distribution,
} = {}) => {
  const msSinceActive = lastAcceptedAt
    ? Date.now() - new Date(lastAcceptedAt).getTime()
    : ms('10m');

  return ({
    role,
    bucket,
    lastAcceptedAt: ms(msSinceActive),
    score: score({ distribution, msSinceActive, rating }).toFixed(2),
    rating: scaleRating(rating)?.toFixed(2),
  });
};

export { score, metrics };
